// blockerActions.js — DeerFlow borrow #1, follow-up: o turn_blocker deixa de ser só
// TEXTO ("Diga 'continue'") e vira AÇÃO clicável no feed. Puro + um dedup one-shot.
//
// Fluxo: blockerFallbackNotice/terminalNotice carimbam metadata.kind='turn_blocker'
// (+ blocker=tipo da taxonomia). O feed renderiza os botões (BlockerActions.jsx);
// clicar dispara `apolo:blockerAction` com um nonce; o useBlockerActions (montado
// por SessionWorkspace) RECLAMA o nonce (one-shot — Chat e Code podem montar o
// mesmo workspace) e envia o prompt via handleSendRef. "Responder" só foca o
// composer (idempotente — dispensa nonce). O DISPATCHER de eventos DOM mora no
// BlockerActions.jsx — este módulo fica folha PURA (gate arch:framework-free).

import { BLOCKER } from './blockerTaxonomy.js';

/** Ações por tipo de blocker. Prompt = o que o clique envia; focus = só foca o composer. */
const ACTIONS = Object.freeze({
  [BLOCKER.CONTINUE]: [
    { id: 'continue', label: 'Continuar', prompt: 'continue' },
  ],
  [BLOCKER.ASK_USER]: [
    { id: 'answer', label: 'Responder', focus: true },
  ],
  [BLOCKER.MISSING_EVIDENCE]: [
    {
      id: 'verify',
      label: 'Rodar verificação',
      prompt: 'Rode a verificação de verdade (testes/build/preview) e mostre a saída real antes de concluir.',
    },
  ],
  [BLOCKER.FAILED]: [
    { id: 'retry', label: 'Tentar de novo', prompt: 'tente de novo — retome exatamente de onde parou' },
  ],
});

/** @returns {Array<{id:string,label:string,prompt?:string,focus?:boolean}>} */
export function blockerActionsFor(metadata) {
  if (!metadata || metadata.kind !== 'turn_blocker') return [];
  return ACTIONS[metadata.blocker] || [];
}

// Dedup one-shot: Chat e Code podem montar o MESMO SessionWorkspace (abas cross-
// surface) — os dois listeners recebem o evento; só o primeiro claim envia.
const claimed = new Set();
export function claimBlockerNonce(nonce) {
  if (!nonce || claimed.has(nonce)) return false;
  claimed.add(nonce);
  if (claimed.size > 128) claimed.delete(claimed.values().next().value);
  return true;
}
